import MainRoutes from "./modules/main";
import SettingsRoutes from "./modules/settings";
import PurchaseDomainRoutes from "./modules/domains/purchase";
import KioskRoutes from "./modules/kiosk";
import ShoppingCartRoutes from "./modules/shopping-cart";
import ApplicationView from "@Components/overhauling/application-view/ApplicationView.vue";
import TeamRoutes from "../modules/teams/routes/TeamRoutes";
import OrganizationRoutes from "../modules/teams/routes/OrganizationRoutes";

export default [
  {
    path: "/",
    component: ApplicationView,
    children: [
      ...MainRoutes,
      SettingsRoutes,
      PurchaseDomainRoutes,
      TeamRoutes(),
      OrganizationRoutes(),
      KioskRoutes,
      ...ShoppingCartRoutes,
    ],
  },

  // catch all redirect
  {
    path: "*",
    redirect: {
      name: "homepage",
    },
  },
];
